import { Mapper } from 'src/base/mapper'
import { PlanTypeEntity } from 'src/data/entities/plan.entity'
import { PlanWithoutUseProductTypeEntity } from 'src/data/entities/subscription.entity'
import { PlanTypeModel } from 'src/domain/models/plan.model'
import { PlanWithoutUseProductTypeModel } from 'src/domain/models/subscription.model'

export class PlanWithoutUseProductMapper extends Mapper<
	PlanWithoutUseProductTypeEntity,
	PlanWithoutUseProductTypeModel
> {
	mapFrom(param: PlanWithoutUseProductTypeEntity): PlanWithoutUseProductTypeModel {
		return {
			productId: param.productId,
			productName: param.productName,
			productDescription: param.productDescription,
			isActive: param.isActive,
			plans: param.plans as PlanTypeModel[],
			plan: param.plan as PlanTypeModel,
			productPicture: param.productPicture,
		}
	}

	mapTo(param: PlanWithoutUseProductTypeModel): PlanWithoutUseProductTypeEntity {
		return {
			productId: param.productId,
			productName: param.productName,
			productDescription: param.productDescription,
			isActive: param.isActive,
			plans: param.plans as PlanTypeEntity[],
			plan: param.plan as PlanTypeEntity,
			productPicture: param.productPicture,
		}
	}
}
